import axios from 'axios';
import { showToastOutsideReact } from '../context/toastContext';
import { clearStorageAndCookies } from './authService';
import { navigateOutsideComponent } from './navigation';


// Hardcoded IPs and ports
const httpServerIp = '172.16.1.239';
const httpServerPort = '80';
const apiServerIp = '172.16.1.239';
const apiServerPort = '80';

// Axios instance
const apiClient = axios.create();

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.status === 401){
      clearStorageAndCookies();
      showToastOutsideReact(error.response?.data?.message, 'error');
      navigateOutsideComponent("/login");
    }
    return Promise.reject(error);
  }
)

// Request Interceptor
/*apiClient.interceptors.request.use(
  (config) => {
    const url = new URL(config.url, `http://${httpServerIp}:${httpServerPort}`);

    // Rewrite logic for "/v-apiserver/REST/"
    if (url.pathname.includes('/v-apiserver/REST/')) {
      console.log(`Rewriting for v-apiserver:`, url.pathname);
      let newPath = url.pathname.replace('/v-apiserver/REST/', '');
      if (url.search) {
        newPath = `${newPath}${url.search}`;
      }
      config.url = `http://${apiServerIp}:${apiServerPort}/v-apiserver/REST/${newPath}`;
    }

    // Rewrite logic for "/v2/stream/"
    if (url.pathname.includes('/v2/stream/')) {
      console.log(`Rewriting for webrtc:`, url.pathname);
      if (url.pathname.includes('/maps/')) {
        const newPath = url.pathname.replace('/maps/', '/');
        config.url = `http://${httpServerIp}:${httpServerPort}${newPath}`;
      } else {
        config.url = `http://${httpServerIp}:${httpServerPort}${url.pathname}`;
      }
    }

    console.log('Modified URL:', config.url);
    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);

// Response Interceptor
apiClient.interceptors.response.use(
  (response) => {
    console.log('Response:', response);
    return response;
  },
  (error) => {
    console.error('Response Error:', error);
    return Promise.reject(error);
  }
);*/
const sanitizeUrl = (url) => url.replace(/([^:]\/)\/+/g, "$1");

/**
 * Reusable GET method for API calls
 * @param {string} api_endpoint - API endpoint to call
 * @returns {Promise<any>} - Response from the server or "failed" on error
 */
export async function getMethod(api_endpoint, signal="") {
  try {
    api_endpoint = `/v-apiserver/REST/${api_endpoint}`;
    api_endpoint = api_endpoint.replace(/\/{2,}/g, '/');
    const response = await apiClient.get(api_endpoint, { signal }, {
      headers: {
        // Include custom headers if needed, e.g., authorization tokens
        // authorization: "your token here",
      },
    });
    return response; // Return the response object
  } catch (error) {
    console.error('Error in getMethod:', error);
    //return "failed"; // Return a "failed" string if an error occurs
    console.log(error.message);
    if(error?.message === 'canceled' && error?.name === 'CanceledError') {
      return {status: 'canceled'}
    }
    return { status: error?.response?.data?.code, data: error?.response?.data }
  }
}


export async function postMethod(api_endpoint, payload) {
  try {
    api_endpoint = `/v-apiserver/REST/${api_endpoint}`;
    api_endpoint = api_endpoint.replace(/\/{2,}/g, '/');
    const response = await apiClient.post(api_endpoint, payload, {
      headers: {
        'Content-Type': 'application/json', // You can modify the Content-Type as necessary
        //'Content-Type': 'multipart/form-data',
        // authorization: "your token here", // Include authorization token if needed
      },
    });

    // Return the status and data from the response
    return { status: response?.data?.code, data: response.data };
  } catch (error) {
    //console.error('Error in postMethod:', error);
    return { status: error?.response?.data?.code, data: error?.response?.data }
  }
}


export async function postMethodFormData(api_endpoint, payload) {
  try {
    api_endpoint = `/v-apiserver/REST/${api_endpoint}`;
    api_endpoint = api_endpoint.replace(/\/{2,}/g, '/');
    const response = await apiClient.post(api_endpoint, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
        // authorization: "your token here", // Include authorization token if needed
      },
    });

    // Return the status and data from the response
    return { status: response?.data?.code, data: response.data };
  } catch (error) {
    console.error('Error in postMethod:', error);
    return { status: error?.response?.data?.code, data: error?.response?.data }
  }
}
export async function putMethod(api_endpoint, payload) {
  try {
    api_endpoint = `/v-apiserver/REST/${api_endpoint}`;
    api_endpoint = api_endpoint.replace(/\/{2,}/g, '/');
    const response = await apiClient.put(api_endpoint, payload, {
      headers: {
        'Content-Type': 'application/json', // Modify Content-Type as necessary
        // authorization: "your token here", // Include authorization token if needed
      },
    });

    // Return the status and data from the response
    return { status: response?.data?.code, data: response.data };
  } catch (error) {
    // Handle error response
    return {
      status: error?.response?.data?.code || error?.response?.status || 500, // Provide fallback status
      data: error?.response?.data || { message: 'An error occurred' },
    };
  }
}

export async function putFormMethod(api_endpoint, payload) {
  try {
    api_endpoint = `/v-apiserver/REST/${api_endpoint}`;
    api_endpoint = api_endpoint.replace(/\/{2,}/g, '/');
    const response = await apiClient.put(api_endpoint, payload, {
      headers: {
        'Content-Type': 'multipart/form-data', // Modify Content-Type as necessary
        // authorization: "your token here", // Include authorization token if needed
      },
    });

    // Return the status and data from the response
    return { status: response?.data?.code, data: response.data };
  } catch (error) {
    // Handle error response
    return {
      status: error?.response?.data?.code || error?.response?.status || 500, // Provide fallback status
      data: error?.response?.data || { message: 'An error occurred' },
    };
  }
}


export async function postFileMethod(api_endpoint, payload) {
  try {
    api_endpoint = `/v-apiserver/REST/${api_endpoint}`;
    api_endpoint = api_endpoint.replace(/\/{2,}/g, '/');
    const response = await apiClient.post(api_endpoint, payload, {
      headers: {
        'content-type': 'multipart/form-data' // You can modify the Content-Type as necessary
        // authorization: "your token here", // Include authorization token if needed
      },
    });

    // Return the status and data from the response
    console.log("0000000000000000000000000000000000000")
    console.log(response)
    return { status: response?.data?.code, data: response.data };
  } catch (error) {
    console.error('Error in postMethod:', error);
    return error.response; // Return a "failed" string if an error occurs
  }
}

export async function deleteMethod(api_endpoint) {
  try {
    api_endpoint = `/v-apiserver/REST/${api_endpoint}`;
    api_endpoint = api_endpoint.replace(/\/{2,}/g, '/');
    const response = await apiClient.delete(api_endpoint, {
      headers: {
        'Content-Type': 'application/json', // You can modify the Content-Type as necessary
        // authorization: "your token here", // Include authorization token if needed
      },
    });

    // Return the status and data from the response
    return { status: response?.data?.code, data: response.data };
  } catch (error) {
    // If error occurs, return status and data from error response
    return { status: error?.response?.data?.code, data: error?.response?.data };
  }
}

export default apiClient;